import React, {useState} from "react";
import ImageGallery from 'react-image-gallery';
import styles from './MobileGallery.module.scss';


export interface IDesktopGalleryProps {
  children?: any;
  galleryOverrides?: any;
  images: { original: string, thumbnail: string }[],
}

const MobileGallery = (props: IDesktopGalleryProps) => {
  const [isInfoShown, setShowInfo] = useState(true);
  return (
    <ImageGallery
      showFullscreenButton={false}
      useBrowserFullscreen={false}
      showPlayButton={false}
      slideInterval={0}
      slideDuration={0}
      lazyLoad={true}
      showIndex={false}
      showThumbnails={false}
      showBullets={!isInfoShown}
      showNav={false}
      disableThumbnailScroll={true}
      disableKeyDown={true}
      items={props.images}
      renderOverlay={() => (<div className={`${styles.overlay} ${isInfoShown ? styles.shown : ''}`.trim()}>
        <div className={styles.overlayContent}>
          {props.children}
        </div>
        <div
          className={styles.grabbableContainer}
          onClick={() => setShowInfo(!isInfoShown)}
        >
          <div
            className={styles.grabbable}
          />
        </div>
      </div>)}

      {...props.galleryOverrides}
    />)
};

MobileGallery.defaultProps = {
  galleryOverrides: {},
};

export default MobileGallery;
